export const validateIsQuestionEntered = userExamAnswer => {
  return Boolean(userExamAnswer && userExamAnswer._enteredOn);
};
